import React from "react";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import ListIcon from "@material-ui/icons/List";
import FolderIcon from "@material-ui/icons/Folder";
import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import { analyseTheme } from "../../analyse/analyseTheme";
import { secondarySoft } from "./sharedStyles";

const styles = (theme: Theme) =>
  createStyles({
    sectionTitle: {
      fontWeight: 600,
      color: analyseTheme.textPrimary,
      marginBottom: theme.spacing.unit * 2,
    },
    actionCard: {
      backgroundColor: analyseTheme.surface,
      border: `1px solid ${analyseTheme.border}`,
      borderRadius: analyseTheme.radius,
      boxShadow: "none",
      padding: theme.spacing.unit * 3,
      height: "100%",
      cursor: "pointer",
      textDecoration: "none",
      color: "inherit",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      transition: "border-color 0.2s, background-color 0.2s",
      "&:hover": {
        borderColor: theme.palette.secondary.light,
        backgroundColor: secondarySoft,
      },
    },
    actionIcon: {
      color: theme.palette.secondary.main,
      marginBottom: theme.spacing.unit,
    },
    actionLabel: {
      fontWeight: 600,
      color: analyseTheme.textPrimary,
    },
    actionDesc: {
      color: analyseTheme.textSecondary,
      fontSize: "0.875rem",
      marginTop: 4,
    },
  });

interface QuickAction {
  label: string;
  desc: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
}

interface Props {
  classes: Record<string, string>;
  isAdmin: boolean;
}

const QuickActionsWidget = ({ classes, isAdmin }: Props) => {
  const quickActions: QuickAction[] = [
    {
      label: "Lots",
      desc: "Voir et gérer tous les lots",
      href: "/batches/0?sort=createdDate,desc",
      icon: ListIcon,
    },
    {
      label: "Projets",
      desc: "Gérer les projets",
      href: "/projects/0?sort=createdDate,desc",
      icon: FolderIcon,
    },
    {
      label: "Analyse",
      desc: "Tableaux de bord et indicateurs",
      href: "/analyse",
      icon: AssessmentOutlinedIcon,
    },
  ].filter(() => isAdmin);

  if (quickActions.length === 0) {
    return null;
  }

  return (
    <>
      <Typography className={classes.sectionTitle} variant="h6">
        Actions rapides
      </Typography>
      <Grid container spacing={16} style={{ marginBottom: 32 }}>
        {quickActions.map((action) => (
          <Grid item xs={12} sm={4} key={action.label}>
            <Link to={action.href} className={classes.actionCard}>
              <action.icon className={classes.actionIcon} />
              <Typography className={classes.actionLabel}>
                {action.label}
              </Typography>
              <Typography className={classes.actionDesc}>
                {action.desc}
              </Typography>
            </Link>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default withStyles(styles)(QuickActionsWidget);
